<script
    lang="ts"
    context="module"
>
    export const formatDate = (date: Date, dateTime: boolean): string => {
        date = new Date(date)
        const day = String(date.getDate()).padStart(2, "0")
        const month = String(date.getMonth() + 1).padStart(2, "0")
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, "0")
        const minutes = String(date.getMinutes()).padStart(2, "0")
        if (dateTime) return `${day}.${month}.${year}`
        else return `${hours}:${minutes} Uhr`
    }
</script>

<script lang="ts">
    export let datetime: Date = null
</script>

<div class="datetimerow">
    {#if datetime}
        <p>{formatDate(datetime, true)}</p>
        <p>{formatDate(datetime, false)}</p>
    {:else}
        <span>Noch nicht gestartet</span>
    {/if}
</div>

<style lang="less">
    .datetimerow {
        display: flex;
        p {
            padding: 0px 0.6rem;
        }
        p:first-child {
            border-right: 1px solid var(--text-100);
        }
    }
</style>
